import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { SeasonStateType } from '@redux/types'
import {
	SeasonCreationType,
	SeasonModificationType,
	SeasonProductBatchUpdateType,
	SeasonProductType,
	SeasonType,
	ProductType,
} from '@schemas'
import dayjs from 'dayjs'

const initialState: SeasonStateType = {
	seasonList: [],
	selectedSeason: null,
	seasonProducts: [],
	products: [],

	selectedYear: dayjs().format('YYYY'),
	loading: false,
	error: null,

	// 페이지 초기화 관련
	triggerInitSeasonPage: false,
}

const seasonSlice = createSlice({
	name: 'season',
	initialState,
	reducers: {
		// 페이지 초기화 관련
		TRIGGER_INIT_SEASON_PAGE: (state, action: PayloadAction<boolean>) => {
			state.loading = true
			state.triggerInitSeasonPage = action.payload
		},
		TRIGGER_INIT_SEASON_PAGE_SUCCESS: state => {
			state.loading = false
		},
		TRIGGER_INIT_SEASON_PAGE_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.loading = false
		},
		// 상품 리스트 관련
		SET_PRODUCT_LIST: (state, action: PayloadAction<ProductType[]>) => {
			state.products = action.payload
		},
		// 시즌 리스트 관련
		SEASON_LIST: (state, action: PayloadAction<SeasonType[]>) => {
			state.seasonList = action.payload
		},
		SET_SELECTED_SEASON: (state, action: PayloadAction<SeasonType | null>) => {
			state.selectedSeason = action.payload
		},
		SET_SELECTED_YEAR: (state, action: PayloadAction<string>) => {
			state.selectedYear = action.payload
		},
		// 시즌 등록 관련
		REGISTER_SEASON: (state, action: PayloadAction<SeasonCreationType>) => {
			state.loading = true
		},
		REGISTER_SEASON_SUCCESS: state => {
			state.loading = false
		},
		REGISTER_SEASON_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.loading = false
		},
		// 시즌 수정 관련
		UPDATE_SEASON: (
			state,
			action: PayloadAction<{
				id: string
				season: SeasonModificationType
			}>,
		) => {
			state.loading = true
		},
		UPDATE_SEASON_SUCCESS: state => {
			state.loading = false
		},
		UPDATE_SEASON_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.loading = false
		},
		// 시즌 삭제 관련
		DELETE_SEASON: (state, action: PayloadAction<string>) => {
			state.loading = true
		},
		DELETE_SEASON_SUCCESS: (state, action: PayloadAction<string>) => {
			state.seasonList = state.seasonList.filter(season => season.id !== action.payload)
			state.loading = false
		},
		DELETE_SEASON_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
			state.loading = false
		},
		// 시즌 상품 관련
		SET_SEASON_PRODUCT_LIST: (state, action: PayloadAction<SeasonProductType[]>) => {
			state.seasonProducts = action.payload
		},
		FETCH_SEASON_PRODUCT: (state, action: PayloadAction<string>) => {
			// This action will be handled in the saga
		},
		// 시즌 상품 수정 관련
		BATCH_UPDATE_SEASON_PRODUCT: (
			state,
			action: PayloadAction<SeasonProductBatchUpdateType[]>,
		) => {
			// This action will be handled in the saga
		},
		BATCH_UPDATE_SEASON_PRODUCT_SUCCESS: state => {
			// This action will be handled in the saga
		},
		BATCH_UPDATE_SEASON_PRODUCT_FAILURE: (state, action: PayloadAction<string>) => {
			state.error = action.payload
		},
	},
})

export const seasonActions = seasonSlice.actions
export default seasonSlice.reducer
